export const widgetStyles = String.raw`
  :host {
    --gd-consent-accent: #69ac27;
    --gd-consent-accent-text: #fff;
    --gd-consent-surface: #fff;
    --gd-consent-text: #000;
    --gd-consent-muted: #333;
    --gd-consent-border: #e4e4e4;
    --gd-consent-soft: #f6f6f6;
    --gd-consent-backdrop: rgb(8 15 24 / 58%);
    --gd-consent-radius: 8px;
    --gd-consent-shadow: 0 0 40px rgb(0 0 0 / 10%);
    --gd-consent-z: 2147483000;
    all: initial;
    color: var(--gd-consent-text);
    font-family: inherit;
    font-size: 16px;
    line-height: 1.5;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  [hidden] {
    display: none !important;
  }

  button, a, input {
    font: inherit;
  }

  button {
    margin: 0;
  }

  .gd-consent__banner {
    position: fixed;
    z-index: var(--gd-consent-z);
    background: var(--gd-consent-surface);
    box-shadow: var(--gd-consent-shadow);
  }

  .gd-consent__banner[data-layout="fluid"] {
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: var(--gd-consent-radius) var(--gd-consent-radius) 0 0;
    padding: 60px clamp(20px, 5vw, 72px);
  }

  .gd-consent__banner[data-layout="box"] {
    bottom: 20px;
    width: min(520px, calc(100vw - 32px));
    border-radius: var(--gd-consent-radius);
    padding: 48px 36px;
  }

  .gd-consent__banner[data-layout="box"][data-position="bottom-right"] {
    right: 20px;
  }

  .gd-consent__banner[data-layout="box"][data-position="bottom-left"] {
    left: 20px;
  }

  .gd-consent__banner-inner {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 32px;
    align-items: center;
    margin: 0 auto;
  }

  .gd-consent__banner-content {
    width: min(648px, 100%);
    text-align: center;
  }

  .gd-consent__eyebrow {
    display: none;
  }

  .gd-consent__title {
    margin: 0;
    color: var(--gd-consent-text);
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 1.3;
  }

  .gd-consent__copy {
    margin: 16px 0 0;
    color: var(--gd-consent-muted);
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
  }

  .gd-consent__privacy {
    display: block;
    color: var(--gd-consent-text);
    font-weight: 400;
    line-height: 26px;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;
  }

  .gd-consent__privacy:hover {
    text-decoration: none;
  }

  .gd-consent__actions {
    display: flex;
    width: min(460px, 100%);
    gap: 16px;
    align-items: center;
  }

  .gd-consent__banner[data-layout="box"] .gd-consent__actions {
    width: 100%;
  }

  .gd-consent__button {
    display: inline-flex;
    min-height: 42px;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
    border-radius: 100px;
    padding: 12px 24px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: .01em;
    line-height: 1;
    text-transform: uppercase;
    transition: transform 120ms ease, box-shadow 120ms ease, background-color 120ms ease;
  }

  .gd-consent__button:hover {
    transform: translateY(-1px);
  }

  .gd-consent__button:focus-visible,
  .gd-consent__privacy:focus-visible,
  .gd-consent__toggle-input:focus-visible + .gd-consent__toggle,
  .gd-consent__close:focus-visible {
    outline: 3px solid color-mix(in srgb, var(--gd-consent-accent) 35%, transparent);
    outline-offset: 3px;
  }

  .gd-consent__button--primary {
    background: var(--gd-consent-accent);
    color: var(--gd-consent-accent-text);
  }

  .gd-consent__button--primary:hover {
    background: color-mix(in srgb, var(--gd-consent-accent) 88%, #000);
  }

  .gd-consent__button--secondary {
    background: var(--gd-consent-soft);
    color: var(--gd-consent-text);
  }

  .gd-consent__button--secondary:hover {
    background: var(--gd-consent-soft);
  }

  .gd-consent__button--link {
    background: var(--gd-consent-surface);
    color: var(--gd-consent-text);
  }

  .gd-consent__banner .gd-consent__button {
    flex: 1 1 0;
    white-space: nowrap;
  }

  .gd-consent__modal {
    position: fixed;
    z-index: calc(var(--gd-consent-z) + 1);
    inset: 0;
    display: grid;
    place-items: center;
    padding: 18px;
  }

  .gd-consent__backdrop {
    position: absolute;
    inset: 0;
    border: 0;
    background: var(--gd-consent-backdrop);
    cursor: default;
  }

  .gd-consent__dialog {
    position: relative;
    width: min(720px, 100%);
    max-height: calc(100vh - 36px);
    overflow: auto;
    border: 0;
    border-radius: var(--gd-consent-radius);
    background: var(--gd-consent-surface);
    padding: 36px;
    outline: 0;
    box-shadow: var(--gd-consent-shadow);
  }

  .gd-consent__close {
    position: absolute;
    top: 15px;
    right: 15px;
    display: grid;
    width: 40px;
    height: 40px;
    place-items: center;
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: var(--gd-consent-muted);
    cursor: pointer;
    line-height: 1;
  }

  .gd-consent__close svg {
    display: block;
    width: 24px;
    height: 24px;
  }

  .gd-consent__close:hover {
    background: var(--gd-consent-soft);
    color: var(--gd-consent-text);
  }

  .gd-consent__dialog-copy {
    margin: 16px 0 0;
    color: var(--gd-consent-muted);
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
  }

  .gd-consent__categories {
    display: grid;
    gap: 16px;
    margin-top: 32px;
  }

  .gd-consent__category {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 20px;
    align-items: start;
    border: 0;
    border-radius: var(--gd-consent-radius);
    background: var(--gd-consent-soft);
    padding: 18px 20px;
  }

  .gd-consent__category-name {
    display: block;
    color: var(--gd-consent-text);
    font-size: 16px;
    font-weight: 600;
  }

  .gd-consent__category-description {
    display: block;
    margin-top: 4px;
    color: var(--gd-consent-muted);
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
  }

  .gd-consent__required {
    align-self: center;
    color: var(--gd-consent-accent);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .04em;
    white-space: nowrap;
    text-transform: uppercase;
  }

  .gd-consent__toggle-wrap {
    position: relative;
    align-self: center;
  }

  .gd-consent__toggle-input {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    opacity: 0;
  }

  .gd-consent__toggle {
    position: relative;
    display: block;
    width: 46px;
    height: 26px;
    border-radius: 999px;
    background: #c8cdd3;
    cursor: pointer;
    transition: background-color 150ms ease;
  }

  .gd-consent__toggle::after {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px rgb(0 0 0 / 25%);
    content: "";
    transition: transform 150ms ease;
  }

  .gd-consent__toggle-input:checked + .gd-consent__toggle {
    background: var(--gd-consent-accent);
  }

  .gd-consent__toggle-input:checked + .gd-consent__toggle::after {
    transform: translateX(20px);
  }

  .gd-consent__dialog-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 32px;
  }

  @media (max-width: 760px) {
    .gd-consent__banner[data-layout="fluid"] {
      padding: 40px 24px;
    }
  }

  @media (max-width: 520px) {
    .gd-consent__dialog {
      padding: 28px 24px;
    }

    .gd-consent__banner[data-layout="box"] {
      right: 12px !important;
      bottom: 12px;
      left: 12px !important;
      width: auto;
      padding: 36px 24px;
    }

    .gd-consent__actions,
    .gd-consent__dialog-actions {
      align-items: stretch;
      flex-direction: column;
    }

    .gd-consent__button {
      width: 100%;
    }

    .gd-consent__category {
      gap: 12px;
      padding: 15px;
    }

    .gd-consent__required {
      max-width: 78px;
      white-space: normal;
      text-align: right;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .gd-consent__button,
    .gd-consent__toggle,
    .gd-consent__toggle::after {
      transition: none;
    }
  }
`;
